import React from "react";
import { AltLayout } from "../common";

import BillManagementPageBody from "./bill-management-page-body";

const BillManagementPage = () => {
  return (
    <AltLayout pageTitle="Bill Management">
      <div className="h-full flex flex-col overflow-y-scroll">
        <div className="max-h-full min-h-0 p-2 mt-8 flex">
          <BillManagementPageBody />
        </div>
      </div>
    </AltLayout>
  );
};

export default BillManagementPage;
